import { useDispatch } from 'react-redux';
import {useEffect, useState} from 'react';
import { TABLES } from '../../../../../Apis/Tables';
import {DeleteItemsApi} from '../../../../../reduxToolkit/Commons/CommonsApi';
import {useParamsContextProvider} from '../../../../../hooks/ParamsContextProvider';
import {TABS_FOODIE} from '../../Model/Models';
import {VIEW_TYPE} from '../../../../../enums/ViewType';
import {errorMsg} from '../../../../../Apis/functions';
import {useTranslation} from "react-i18next";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IngredientsApp = ({setModified}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const [selectedList, setSelectedList] = useState([]);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);

    const handleDelete = (item) => {
        setSelectedList([item.id]);
        if(setParamsContext){
            setParamsContext(prev => ({
                ...prev,
                modalDelete: true
            }));
        }
    }


    /**
     * useEffect to open the delete modal based on the modalDelete variable from the context and selectForDelete
     */
    useEffect(() => {
        if(paramsContext && paramsContext?.tabIndex == TABS_FOODIE.INGREDIENTS.INDEX && selectedList?.length > 0)
            setDeleteModalShow(paramsContext.modalDelete)
    }, [paramsContext]);

    /**
     * Clears the list of items to delete
     */
    useEffect(() => {
        if(!deleteModalShow)
            setSelectedList([])
    }, [deleteModalShow]);

    /**
     * Disable the delete button from the context and/or globally
     */
    useEffect(() => {
        if(paramsContext && paramsContext?.tabIndex == TABS_FOODIE.INGREDIENTS.INDEX){
            setParamsContext(prev => ({
                ...prev,
                disabledBtnDelete: selectedList?.length <= 0
            }));
        }
    }, [selectedList]);

    /**
     * Function that calls the global API to delete a single ingredient or a list of ingredients
     */
    const handleDeleteSelected = () => {
        if (selectedList.length > 0) {
            dispatch(DeleteItemsApi({ tableName: TABLES.INGREDIENT , body: selectedList })).then(({payload: {data: { success, code  }}}) => {
                if (success === true) {
                    setModified(true);
                    setSelectedList([]);
                    setIsAllChecked(false);
                    handleDeleteModalClose();
                }else{
                    setIsAllChecked(false);
                    errorMsg(code)
                }
            });
        }
    };

    /**
     * Function to hide the delete modal
     */
    const handleDeleteModalClose = () => {
        if(setParamsContext){
            setParamsContext(prev => ({
                ...prev,
                modalDelete: false
            }));
        }
    }

    return {
        t,
        view,
        setView,
        isAllChecked,
        setIsAllChecked,
        deleteModalShow,
        selectedList,
        setSelectedList,
        handleDeleteSelected,
        handleDeleteModalClose,
        handleDelete
    }

}

export default IngredientsApp;
